// Standard Create React App service-worker registration helper, inlined here
// because this repo was scaffolded before CRA started shipping it by default.
// Registers /service-worker.js in production builds only (HMR conflicts with
// the SW in dev, and dev restarts would leave stale registrations behind).

const isLocalhost = Boolean(
  typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '[::1]' ||
      window.location.hostname.match(/^127(?:\.[0-9]+){0,2}\.[0-9]+$/))
);

export function register() {
  if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
    return;
  }

  const publicUrl = new URL(process.env.PUBLIC_URL || '/', window.location.href);
  if (publicUrl.origin !== window.location.origin) {
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl);
    } else {
      registerValidSW(swUrl);
    }
  });
}

function registerValidSW(swUrl) {
  navigator.serviceWorker
    // updateViaCache: 'none' forces the browser to fetch /service-worker.js
    // bypassing the HTTP cache on every update check, so a freshly deployed
    // (build-stamped) worker is detected immediately rather than up to 24h
    // later — the byte-changed SW then skipWaiting()s and controllerchange
    // reloads open tabs onto the new build.
    .register(swUrl, { updateViaCache: 'none' })
    .then((registration) => {
      // Installed PWAs (especially iOS home-screen) stay alive across deploys
      // and only re-check for a new worker when asked. Trigger an update check
      // every time the app is foregrounded so users get the latest build
      // automatically instead of having to delete + reinstall (SMRTSTATS-362).
      const requestUpdate = () => {
        registration.update().catch(() => {});
      };
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') requestUpdate();
      });
      window.addEventListener('focus', requestUpdate);
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.error('Service worker registration failed:', error);
    });

  // Auto-reload when a new SW takes control. The SW itself already calls
  // skipWaiting() on install and clients.claim() on activate, so as soon as
  // a new build deploys and the browser sees the updated /service-worker.js
  // the new worker activates and fires `controllerchange` on every open tab.
  // We then reload once so the tab fetches the fresh index.html + bundle
  // hash. Without this, a tab that was open across a deploy keeps trying
  // to load the OLD bundle hash from its cached SPA shell — and our /static
  // path 404s back to index.html, which references the old hash again,
  // looping forever (observed during the SMRTSTATS-297 smoke test).
  //
  // Guard: skip the very first controllerchange on a virgin install (no
  // prior controller) — that one isn't an update, it's the initial claim,
  // and reloading there is pointless.
  if (navigator.serviceWorker.controller) {
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  }
}

function checkValidServiceWorker(swUrl) {
  fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl);
      }
    })
    .catch(() => {
      // eslint-disable-next-line no-console
      console.log('No internet connection found. App is running in offline mode.');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      // eslint-disable-next-line no-console
      .catch((error) => console.error(error.message));
  }
}
